module.exports = __webpack_public_path__ + "img/ic_loads.394f96cb.svg";